var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model from "@ember-data/model";
import Store from "@ember-data/store";
import { service } from "@ember/service";
import Creator from "core/models/creator";
import JournalEvent from "core/models/journal-event";
import SemeiaSessionService from "core/services/session";

/**
 * This class is here to handle and share the concept of 'responsible'
 * which is saved as a 'responsibleId' and a 'responsibleType'.
 *
 * This is usefull for journal events that represent a planification like 'task-planned'
 * or 'consultation-planned'.
 *
 * It may be enriched by other behavior that they need to share
 */
let PlanifiedJournalEvent = (_class = class PlanifiedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
  }
  get hasResponsible() {
    return Boolean(this.responsibleType) && Boolean(this.responsibleId);
  }
  get currentUserIsResponsible() {
    if (!this.responsibleType) return false;
    const user = this.session[this.responsibleType.toLowerCase()];
    return user?.id == this.responsibleId;
  }
  get responsibleIsPatient() {
    return this.responsibleType == "patient";
  }

  /**
   * There is no network request done there.
   * The Creator should already been in the store otherwise it will return null.
   * So don't use this to check if the task has a responsible but use 'hasResponsible'
   */
  get responsible() {
    if (this.responsibleType != null && this.responsibleId != null) {
      const responsible = this.store.peekRecord(this.responsibleType, this.responsibleId);
      if (!responsible) {
        throw `No responsible found in the store with the type '${this.responsibleType}' corresponding to the id '${this.responsibleId}'`;
      }
      return responsible;
    }
    return null;
  }
  set responsible(creator) {
    if (!creator) {
      this.responsibleId = undefined;
      this.responsibleType = undefined;
    } else if (creator instanceof Creator) {
      this.responsibleId = parseInt(creator.id);
      this.responsibleType = creator.constructor.modelName;
    } else {
      throw "You pass a responsible which is not of type 'Creator'.";
    }
  }
  isResponsible(creator) {
    if (creator) {
      return creator.constructor.modelName == this.responsibleType && parseInt(creator.id) == this.responsibleId;
    }
    return false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PlanifiedJournalEvent as default };